export default __webpack_public_path__ + "static/media/trash1.9bf48ea8.svg";